import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { SyncKind, SyncStatus } from "../../lib/types";

const ACTIVE_STATUSES = new Set(["queued", "running", "importing"]);

export const useSyncStatus = () =>
	useQuery({
		queryKey: ["sync"],
		queryFn: () => api.get<SyncStatus>("/api/sync"),
		refetchInterval: (query) => {
			const status = query.state.data;
			const active =
				ACTIVE_STATUSES.has(status?.products?.status ?? "") ||
				ACTIVE_STATUSES.has(status?.inventory?.status ?? "") ||
				ACTIVE_STATUSES.has(status?.sellingPlans?.status ?? "") ||
				ACTIVE_STATUSES.has(status?.collections?.status ?? "");
			return active ? 3000 : false;
		},
	});

export const useStartSync = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (kind: SyncKind) => api.post<{ queued: boolean }>(`/api/sync/${kind}`),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["sync"] }),
	});
};
